var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Home = forwardRef(function (props, ref) { return (_jsx(StyledIcon, __assign({ ref: ref, viewBox: "0 0 31 30", a11yTitle: "Home" }, props, { children: _jsx("path", { d: "M25.1665 26.7526H19.6285C18.7787 26.7526 18.0902 26.064 18.0902 25.2142V19.6762C18.0902 18.9962 17.5394 18.4455 16.8595 18.4455H14.3981C13.7182 18.4455 13.1675 18.9962 13.1675 19.6762V25.2142C13.1675 26.064 12.4789 26.7526 11.6291 26.7526H6.09108C5.2413 26.7526 4.55273 26.064 4.55273 25.2142V13.4693C4.55273 12.0546 5.2013 10.7181 6.31198 9.84308L15.0572 2.95192C15.3925 2.68855 15.8651 2.68855 16.1998 2.95192L24.9462 9.84308C26.0569 10.7181 26.7049 12.054 26.7049 13.468V25.2142C26.7049 26.064 26.0163 26.7526 25.1665 26.7526Z", fill: "#000" }) }))); });
//# sourceMappingURL=Home.js.map